import './progress_select.scss';

import classnames from 'classnames';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import React from 'react';

import { allStagesEnum } from '../../opportunities/constants';

class ProgressSelect extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const { onChange, name, resourceName, options } = this.props;
    const newValue = event.target.dataset.value;

    if (
      this.props.value !== newValue &&
      options.find(option => option.value === newValue)?.lost &&
      // eslint-disable-next-line no-alert
      !window.confirm(
        `You are about to mark "${resourceName}" as lost. Are you sure you want to do this?`,
      )
    ) {
      return;
    }

    const syntheticSyntheticEvent = {
      target: {
        value: newValue,
        name,
        type: 'progressSelect',
      },
    };
    onChange(syntheticSyntheticEvent);
  }

  render() {
    const {
      options,
      value: currentValue,
      onChange,
      readOnly,
      isSalesforceOpp,
    } = this.props;
    const currentOptionIdx = options.findIndex(ea => ea.value === currentValue);
    const salesforceReadOnlyStage = stage =>
      isSalesforceOpp &&
      !(
        currentValue === allStagesEnum.CLOSED_WON.value ||
        currentValue === allStagesEnum.AGREED.value
      ) &&
      stage !== allStagesEnum.CLOSED_LOST.value;
    return (
      <ul className="c-progress_select list-unstyled m-0">
        {options.map(({ label, value, agreed, lost, disabled }, idx) => (
          <li key={value}>
            <button
              type="button"
              className={classnames('c-progress_select__chevron', {
                'c-ps__chevron--agreed': agreed,
                'c-ps__chevron--lost': lost,
                'c-ps__chevron--past': idx < currentOptionIdx,
                'c-ps__chevron--current': idx === currentOptionIdx,
                'c-ps__chevron--future': idx > currentOptionIdx,
              })}
              disabled={
                salesforceReadOnlyStage(value) ||
                readOnly ||
                !onChange ||
                idx === currentOptionIdx ||
                disabled ||
                (currentValue === allStagesEnum.CLOSED_WON.value &&
                  idx < currentOptionIdx) ||
                (value === allStagesEnum.CLOSED_WON.value &&
                  currentValue !== allStagesEnum.AGREED.value)
              }
              data-value={value}
              onClick={this.handleClick}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    );
  }
}

ProgressSelect.propTypes = {
  name: string.isRequired,
  resourceName: string,
  value: string,
  onChange: func,
  readOnly: bool,
  options: arrayOf(
    shape({
      value: string.isRequired,
      label: string.isRequired,
      disabled: bool,
      agreed: bool,
      lost: bool,
    }),
  ).isRequired,
  isSalesforceOpp: bool,
};

ProgressSelect.defaultProps = {
  resourceName: 'New Opportunity',
  onChange: undefined,
  value: '',
  readOnly: false,
  isSalesforceOpp: false,
};

export default ProgressSelect;
